export enum TimePickerFormat {
  HourMinuteSecond = 'HH:mm:ss',
  HourMinute = 'HH:mm'
}
